import { defineComponent as o, openBlock as r, createBlock as a, normalizeProps as n, guardReactiveProps as l, withCtx as p, renderSlot as s, createElementVNode as c } from "vue";
import m from "../CdrIcon.vue.mjs";
const d = /* @__PURE__ */ c("path", {
  role: "presentation",
  d: "M13.406 12.006l3.297-3.296a1 1 0 10-1.414-1.414l-3.297 3.295-3.285-3.295A1 1 0 107.293 8.71l3.285 3.295-3.285 3.288a1 1 0 001.414 1.415l3.285-3.289 3.297 3.289a1 1 0 001.414-1.415l-3.297-3.287z"
}, null, -1), f = /* @__PURE__ */ o({
  name: "XSm",
  __name: "x-sm",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (t, i) => (r(), a(m, n(l(e.props)), {
      default: p(() => [s(t.$slots, "default"), d]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
